/**
 * 权限注册路径处理
 */
import store from '../../store'
import { session } from '../../plugin/storage'

const WX_CONF_URL = '_wx_conf_url_'

const handleWxUrl = to => {
  if (!session.get(WX_CONF_URL)) {
    session.set(WX_CONF_URL, `${location.origin}${location.pathname}`)
  }

  let url = ''

  // iOS设配
  if (window.__wxjs_is_wkwebview) {
    url = session.get(WX_CONF_URL)
  }
  // Android设配
  if (!window.__wxjs_is_wkwebview) {
    url = location.href.split('#')[0]
  }

  store.commit('wxurl/setWxConfUrl', url)
}

export default handleWxUrl
